jQuery(document).ready(function($){
    $('*[data-clone-class]').each(function() {
        var clone_class = $(this).attr('data-clone-class');
        var parent = $(this).parent();
        var clone = parent.find('.'+clone_class).not('[data-clone-class]').clone(true,true);
        $(this).html(clone.html());
    });
});